export default __webpack_public_path__ + "static/media/face_2_15.cdfe91cf.png";